import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	padding: 10em 5em;
	margin: 0 auto;
	text-align: center;

	.header,
	.public-layout-forms-login-form {
		max-width: 30em;
		margin: 0 auto;
	}

	.header {
		display: flex;
		flex-flow: column nowrap;
		justify-content: center;
		align-items: center;
	}

	.header-mobile,
	.mobile-links {
		display: none;
	}

	.logo {
		margin: 0 auto 3em auto;
		height: 4.5em;
	}

	.layout-default {
		.public-layout-navigation-topbar,
		.public-layout-navigation-footer {
			display: none;
		}
	}

	@media all and (max-width: ${vars.mobileL}) {
		padding: 0;
		background-color: ${vars.colorBackgroundContrastDark};

		.header {
			display: none;
		}

		.header-mobile {
			background-color: ${vars.colorBackgroundContrast};
			padding: 0.6em;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.logo {
			margin: 0 auto;
			max-width: 60%;
		}

		.mobile-links {
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 0 3em;
			margin: 1em 0;

			.links {
				display: flex;
				min-width: 100%;

				.links-page {
					padding: 0.7em 2em;
					font-size: 1.1em;
					width: 50%;
					border-radius: 0.3em;
					color: ${vars.colorText};
					display: flex;
					justify-content: center;
					align-items: center;
					text-decoration: none;
				}
				.current-page {
					background-color: ${vars.colorElement};
					border: 0.09em solid ${vars.colorElement};
					transform: translate(2%);
				}
				.link-register {
					border: 0.09em solid ${vars.colorBorder};
				}
			}
		}

		.public-layout-forms-login-form {
			padding: 1em 3em;

			.label-wrapper {
				.label-body {
					.layout-forms-input-label {
						opacity: 1;
					}
				}
			}
		}

		.password-reset-button {
			font-size: 1.2em;
			text-decoration: underline;
		}

		.log-in-button {
			font-size: 1.2em;
			.button {
				padding: 1em 2.5em;
			}
		}
		.footer-title {
			font-size: 1.2em;
		}
		.footer {
			.subtitle {
				font-size: 1.3em;
			}
			.register-link {
				margin-top: 0.4em;
				font-size: 1.4em;
			}
		}

		.layout-default {
			.public-layout-navigation-topbar-mobile {
				display: none;
			}
		}
	}
`;
